exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/front-page.js-WebpackMultiOutput";